import { Button, ButtonGroup, CircularProgress, FormControl, IconButton, InputLabel, makeStyles, MenuItem, OutlinedInput, Select } from '@material-ui/core';
import { ArrowForwardIos } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { MdAdd, MdArrowForward, MdCancel, MdLogout } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';
import { CancelCrudButtons } from '../../components/ui/CancelCrudButtons';
import { InputContainer } from '../../components/ui/InputContainer';
import { InputField } from '../../components/ui/InputField';
import { Modal } from '../../components/ui/Modal';
import { IServiceUserInfo } from '../../datasolvr/ServicesFacade';
import { useKeyPress } from '../../hooks/useKeyPress';
import { IOnboardingContent } from '../../interface/interface';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { ICompanyContent, IEaterGroupContent, IOfficeContent, IUserContent, IVersionedObject } from '../../planEatApi/PlanEatFacade';
import { clone } from '../../utils/clone';
import { resetEaterGroup } from '../../utils/resetObjects';

const useStyles = makeStyles((theme: any) => ({
    container: {
        padding: 20,
        display: "flex",
        flexDirection: "column",
        rowGap: 25,
        "& > *": {
            width: "100%",
            maxWidth: 1000
        }
    },
    selectedOption: {
        backgroundColor: theme.palette.primary.main,
        color: "white !important",
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        }
    },
    joinEaterGroupContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        rowGap: 25,
    },
    existingUserContainer: {
        maxHeight: 200,
        overflowY: "scroll",
        overflow: "hidden",
        background: "#b5b2b1",
        padding: 15,
        borderRadius: 8,
        marginBottom: 25
    },
    addingEmailContainer: {
        display: "grid",
        gridTemplateColumns: "auto 65px",
        columnGap: 15,
        width: "100%",
        marginTop: 25
    },
    emailContainer: {
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        marginTop: 25,
        columnGap: 10,
        rowGap: 10,
        width: "100%",
        flexWrap: "wrap",
        flexDirection: "row",
        marginBottom: 25
    },
    email: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
        borderRadius: 8,
        padding: "5px 10px 5px 10px",
    },
    adminEmail: {
        backgroundColor: "black",
        color: "white",
        borderRadius: 8,
        padding: "5px 10px 5px 10px",
    },
    bottomBar: {
        color: 'white',
        background: 'linear-gradient(45deg, ' + theme.palette.primary.main + ' 30%, ' + theme.palette.secondary.main + ' 90%)',
        position: 'fixed',
        left: 0,
        bottom: 0,
        height: 50,
        width: '100%',
        paddingLeft: 15,
        paddingRight: 10,
        zIndex: 20,

        "& > *": {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            height: "100%",
            fontWeight: "bold",
            cursor: "pointer",
            columnGap: 5
        }
    },
    inputContainer: {
        display: "grid",
        gridTemplateColumns: "auto auto",
        alignItems: "start",
        gap: 15,
        marginTop: 25,
        marginBottom: 25,
        width: "100%"
    },
    topRow: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between"
    }
}));

interface Props {
    haveLougout?: boolean;
    companyContent?: ICompanyContent;
}

export const Onboarding: React.FC<Props> = ({ haveLougout, companyContent }) => {
    const classes = useStyles()
    const history = useHistory();

    const [company, setCompany] = useLocalStorage('onboarding_company', "")
    const [office, setOffice] = useState("");
    const [eaterGroup, setEaterGroup] = useState("");

    const [companies, setCompanies] = useState<IVersionedObject<ICompanyContent>[]>([]);
    const [offices, setOffices] = useState<IVersionedObject<IOfficeContent>[]>([]);
    const [eaterGroups, setEaterGroups] = useState<IVersionedObject<IEaterGroupContent>[]>([]);
    const [users, setUsers] = useState<IVersionedObject<IUserContent>[]>([]);
    const [serviceUsers, setServiceUsers] = useState<IServiceUserInfo[]>([])

    const [currOffices, setCurrOffices] = useState<IVersionedObject<IOfficeContent>[]>([]);
    const [currEaterGroups, setCurrEaterGroups] = useState<IVersionedObject<IEaterGroupContent>[]>([]);
    const [currUsers, setCurrUsers] = useState<IVersionedObject<IUserContent>[]>([])

    const [addingUserEmail, setAddingUserEmail] = useState("")
    const [addedUserEmails, setAddedUserEmails] = useState<string[]>([])
    const [addingAdminEmail, setAddingAdminEmail] = useState("")
    const [addedAdminEmails, setAddedAdminEmails] = useState<string[]>([])

    const [isCreatingEaterGroup, setIsCreatingEaterGroup] = useLocalStorage('is_creating_eater_group', true)
    const [eaterGroupSearchStr, setEaterGroupSearchStr] = useState("")
    const [isConfirmSelectionHidden, setIsConfirmSelectionHidden] = useState(true)

    const [isSendingOnboardingMails, setIsSendingOnboardingMails] = useState(false)

    const [eaterGroupContent, setEaterGroupContent] = useState<IEaterGroupContent>({
        id: "",
        name: "",
        description: "",
        officeId: "",
        eaterGroupName: "",
        eaterGroupCVR: "",
        eaterGroupAddress: "",
        eaterGroupPhoneNumber: "",
        eaterGroupAdminIds: [],
    });

    function getDatabase() {
        planEatApi.getCompanies()
            .then((response) => {
                setCompanies(response.data);
                response.data.length > 0 && company === "" && setCompany(response.data[0].content.id);
            })
            .catch((e) => console.log(e))
        planEatApi.getOffices()
            .then((response) => { setOffices(response.data) })
            .catch((e) => console.log(e))
        planEatApi.getEaterGroups()
            .then((response) => setEaterGroups(response.data))
            .catch((e) => console.log(e))
        planEatApi.getUsers()
            .then((response) => setUsers(response.data))
            .catch((e) => console.log(e))
        planEatApi.getServiceUsers()
            .then((response => { setServiceUsers(response.data) }))
            .catch((e) => console.log(e))
    }

    useEffect(() => {
        getDatabase()
    }, [])

    useEffect(() => {
        if(companyContent){
            const newCurrOffices = offices.filter(item => item.content.companyId === companyContent.id)
            setCurrOffices(newCurrOffices)
            newCurrOffices.length > 0 && setOffice(newCurrOffices[0].content.id)
            setEaterGroup("")
        } else {
            const newCurrOffices = offices.filter(item => item.content.companyId === company)
            setCurrOffices(newCurrOffices)
            newCurrOffices.length > 0 && setOffice(newCurrOffices[0].content.id)
            setEaterGroup("")
        }
    }, [company, offices])

    useEffect(() => {
        const newCurrEaterGroups = eaterGroups.filter(item => item.content.officeId === office)
        setCurrEaterGroups(newCurrEaterGroups)
    }, [office, eaterGroups])

    useEffect(() => {
        const newCurrUsers = users.filter(item => item.content.eaterGroupId === eaterGroup)
        setCurrUsers(newCurrUsers)

        // Update input string for auto complete
        if (eaterGroupSearchStr === "" && eaterGroup !== "") {
            const selectedEaterGroup = eaterGroups.find(item => item.content.id === eaterGroup)
            selectedEaterGroup && setEaterGroupSearchStr(selectedEaterGroup.content.eaterGroupName)
        }
    }, [eaterGroup])

    useEffect(() => {
        if (eaterGroupSearchStr === "") {
            setEaterGroup("")
        }
    }, [eaterGroupSearchStr])

    function userInfoStr(applicationUserId: string) {
        const serviceUser = serviceUsers.find(serviceUser => serviceUser.content.id === applicationUserId)
        if (serviceUser) {
            return serviceUser.content.id + " (" + serviceUser.content.name + ")"
        } else {
            return ""
        }
    }

    const validEmail: RegExp = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;

    function addEmail(isAdmin: boolean) {
        if (isAdmin) {
            if (!validEmail.test(addingAdminEmail)) {
                toast.error("Enter valid email")
            } else {
                if (addingAdminEmail.length === 0) {
                    toast.error("Please enter an email")
                } else {
                    if (!addedAdminEmails.find(email => email === addingAdminEmail) && !addedUserEmails.find(email => email === addingAdminEmail)) {
                        setAddedAdminEmails(addedAdminEmails => [...addedAdminEmails, addingAdminEmail]);
                        setAddingAdminEmail("")
                    } else {
                        toast.error("Email: " + addingAdminEmail + " already added")
                    }
                }
            }
        } else {
            if (!validEmail.test(addingUserEmail)) {
                toast.error("Enter valid email")
            } else {
                if (addingUserEmail.length === 0) {
                    toast.error("Please enter an email")
                } else {
                    if (!addedUserEmails.find(email => email === addingUserEmail) && !addedAdminEmails.find(email => email === addingUserEmail)) {
                        setAddedUserEmails(addedUserEmails => [...addedUserEmails, addingUserEmail]);
                        setAddingUserEmail("")
                    } else {
                        toast.error("Email: " + addingUserEmail + " already added")
                    }
                }
            }
        }
    }

    function removeEmail(isAdmin: boolean, removedEmail: string) {
        if (isAdmin) {
            const newAddedAdminEmail: string[] = []
            addedAdminEmails.forEach(email => {
                if (email !== removedEmail) {
                    newAddedAdminEmail.push(email)
                }
            })
            setAddedAdminEmails(newAddedAdminEmail);
        } else {
            const newAddedUserEmail: string[] = []
            addedUserEmails.forEach(email => {
                if (email !== removedEmail) {
                    newAddedUserEmail.push(email)
                }
            })
            setAddedUserEmails(newAddedUserEmail);
        }
    }

    function postOnboardEaterGroup() {
        setIsSendingOnboardingMails(true)
        const tmpEaterGroupContent = clone<IEaterGroupContent>(eaterGroupContent)
        tmpEaterGroupContent.officeId = office
        if (eaterGroup !== "") {
            tmpEaterGroupContent.id = eaterGroup
        }

        const adminUsersEmails = addedAdminEmails.map(email => {
            return email.toLowerCase()
        })
        const eaterUsersEmails = addedUserEmails.map(email => {
            return email.toLowerCase()
        })

        const onboardingContent: IOnboardingContent = {
            eaterGroupContent: tmpEaterGroupContent,
            adminUsers: adminUsersEmails,
            eaterUsers: eaterUsersEmails
        }

        planEatApi.postOnboardEaterGroup(onboardingContent)
            .then((response) => {
                toast.success("Onboarding emails was successfully sent")
                setIsSendingOnboardingMails(false)
                setIsConfirmSelectionHidden(true)
                setEaterGroupContent(resetEaterGroup)
                setAddedAdminEmails([])
                setAddedUserEmails([])
                setAddingAdminEmail("")
                setAddingUserEmail("")
            })
            .catch((e) => {
                if (e.response.data.content.length > 0) {
                    toast.error(e.response.data.content[e.response.data.content.length - 1].message)
                } else {
                    toast.error("Failed sending onboarding emails to users")
                }
                setIsSendingOnboardingMails(false)
            })
    }

    function postLogout() {
        const LSUserId = localStorage.getItem("userId")
        localStorage.clear()
        if (LSUserId) {
            const userId = users.find(user => user.content.id === LSUserId)
            if (userId) {
                planEatApi.postLogout(userId.content.applicationUserId)
                    .then((response) => {
                        console.log(response);
                        history.push("/")
                    })
                    .catch((e) => {
                        history.push("/")
                        console.log(e)
                    })
            } else {
                history.push("/")
            }
        } else {
            history.push("/")
        }
    }

    const handleCompanyChange = (event: any) => {
        setCompany(event.target.value);
    };

    const handleOfficeChange = (event: any) => {
        setOffice(event.target.value);
    };

    const handleEaterGroupChange = (prop: keyof IEaterGroupContent) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setEaterGroupContent({ ...eaterGroupContent, [prop]: event.target.value });
    };

    const handleEnterKeyDown = (event: React.KeyboardEvent, isAdmin: boolean) => {
        if (event.key === "Enter") {
            addEmail(isAdmin)
        }
    }

    return (
        <div className={classes.container}>
            <div className={classes.topRow}>
                <h1>Onboarding</h1>
                {
                    haveLougout &&
                    <Button variant='text' color="default" onClick={() => { postLogout() }} >
                        <MdLogout /> Logout
                    </Button>
                }
            </div>

            {/* Generic part of onboarding form */}
            {
                !companyContent &&
                    <FormControl variant="outlined" style={{ marginTop: 10 }}>
                        <InputLabel shrink>Select company</InputLabel>
                        <Select
                            input={<OutlinedInput notched label="Select company" />}
                            label='Select company'
                            variant='outlined'
                            value={company}
                            onChange={handleCompanyChange}
                            fullWidth
                        >
                            {companies.map(item => <MenuItem key={item.content.id} value={item.content.id}>{item.content.companyName}</MenuItem>)}
                        </Select>
                    </FormControl>
            }
            <FormControl variant="outlined" style={{ marginTop: 10 }}>
                <InputLabel shrink>Select office</InputLabel>
                <Select
                    input={<OutlinedInput notched label="Select office" />}
                    label='Select office'
                    variant='outlined'
                    value={office}
                    onChange={handleOfficeChange}
                    fullWidth
                >
                    {currOffices.map(item => <MenuItem key={item.content.id} value={item.content.id}>{item.content.officeName}</MenuItem>)}
                </Select>
            </FormControl>
            <ButtonGroup size="large" color="primary" aria-label="outlined primary button group">
                <Button className={isCreatingEaterGroup ? classes.selectedOption : ""} onClick={() => { setIsCreatingEaterGroup(true) }}>Create Eater Group</Button>
                <Button className={!isCreatingEaterGroup ? classes.selectedOption : ""} onClick={() => { setIsCreatingEaterGroup(false) }}>Join Eater Group</Button>
            </ButtonGroup>


            {
                isCreatingEaterGroup ?
                    <div>
                        {/* Specific form: Create eater group */}
                        <div className={classes.inputContainer}>
                            <InputField
                                fullWidth
                                variant='outlined'
                                id="groupCompany"
                                label="Eater Group name"
                                name="groupCompany"
                                value={eaterGroupContent.eaterGroupName}
                                onChange={handleEaterGroupChange('eaterGroupName')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required />
                            <InputField
                                fullWidth
                                id="groupCvr"
                                label="Eater Group CVR"
                                name="groupCvr"
                                autoComplete="groupCvr"
                                variant="outlined"
                                helperText='If you don´t have a CVR number, stay blank'
                                value={eaterGroupContent.eaterGroupCVR}
                                onChange={handleEaterGroupChange('eaterGroupCVR')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required />
                            <InputField
                                margin="normal"
                                fullWidth
                                id="groupAddress"
                                label="Eater Group Address"
                                name="groupAddress"
                                autoComplete="groupAddress"
                                variant="outlined"
                                value={eaterGroupContent.eaterGroupAddress}
                                onChange={handleEaterGroupChange('eaterGroupAddress')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required />
                            <InputField
                                margin="normal"
                                fullWidth
                                id="groupPhoneNumber"
                                label="Eater Group Phone Number"
                                name="groupPhoneNumber"
                                autoComplete="groupPhoneNumber"
                                variant="outlined"
                                value={eaterGroupContent.eaterGroupPhoneNumber}
                                onChange={handleEaterGroupChange('eaterGroupPhoneNumber')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required />
                        </div>
                    </div>
                    :
                    <div className={classes.joinEaterGroupContainer}>
                        {/* Specific form: Create join group */}
                        <Autocomplete
                            id="users"
                            options={currEaterGroups}
                            onChange={(event, newValue) => {
                                newValue?.content && setEaterGroup(newValue?.content.id)
                            }}
                            renderInput={params => (
                                <InputField {...params} label="Select Eater Group" variant="outlined" />
                            )}
                            getOptionLabel={option => option.content.eaterGroupName}
                            style={{ width: "100%" }}
                            inputValue={eaterGroupSearchStr}
                            onInputChange={(event, newInputValue) => {
                                setEaterGroupSearchStr(newInputValue);

                            }}
                        />
                        <h5>Existing user in {eaterGroups.find(item => item.content.id === eaterGroup)?.content.eaterGroupName}</h5>
                        <div className={classes.existingUserContainer}>
                            {currUsers.map(user => (
                                <div>
                                    {userInfoStr(user.content.applicationUserId)}
                                </div>
                            ))}
                        </div>
                    </div>
            }

            {/* Adding admins and eaters */}
            <div>
                <div>
                    <h5>Add admin users to {eaterGroupContent.eaterGroupName}</h5>
                    <div className={classes.addingEmailContainer}>
                        <InputField
                            label={"Enter admin email"}
                            variant="outlined"
                            value={addingAdminEmail}
                            onChange={(e) => { setAddingAdminEmail(e.target.value) }}
                            onKeyDown={(e) => handleEnterKeyDown(e, true)}
                            type="email"
                        />
                        <IconButton color='primary' onClick={() => { addEmail(true) }}>
                            <MdAdd />
                        </IconButton>
                    </div>
                    <div className={classes.emailContainer}>
                        {addedAdminEmails.map(adminEmail => (
                            <div className={classes.adminEmail}>
                                {adminEmail} <MdCancel style={{ cursor: "pointer" }} onClick={() => { removeEmail(true, adminEmail) }} />
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    <h5>Add eater users to {eaterGroupContent.eaterGroupName}</h5>
                    <div className={classes.addingEmailContainer}>
                        <InputField
                            label={"Enter eater email"}
                            variant="outlined"
                            value={addingUserEmail}
                            onChange={(e) => { setAddingUserEmail(e.target.value) }}
                            onKeyDown={(e) => handleEnterKeyDown(e, false)}
                            type="email"
                        />
                        <IconButton color='primary' onClick={() => { addEmail(false) }}>
                            <MdAdd />
                        </IconButton>
                    </div>
                    <div className={classes.emailContainer}>
                        {addedUserEmails.map(email => (
                            <div className={classes.email}>
                                {email} <MdCancel style={{ cursor: "pointer" }} onClick={() => { removeEmail(false, email) }} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>


            {/* Bottom navigation bar */}
            <div>
                {
                    ((!isCreatingEaterGroup && addedUserEmails.length > 0 || addedAdminEmails.length > 0) || (isCreatingEaterGroup && addedAdminEmails.length > 0)) &&
                    <div className={classes.bottomBar}>
                        {
                            isCreatingEaterGroup ?
                                <div onClick={() => { setIsConfirmSelectionHidden(false) }}>
                                    Create {eaterGroupContent.eaterGroupName} w. {addedAdminEmails.length} admin(s) and {addedUserEmails.length} eater(s) <ArrowForwardIos />
                                </div>
                                :
                                <div onClick={() => { setIsConfirmSelectionHidden(false) }}>
                                    Add {addedUserEmails.concat(addedAdminEmails).length} to {eaterGroups.find((item) => item.content.id === eaterGroup)?.content.eaterGroupName} <ArrowForwardIos />
                                </div>
                        }
                    </div>
                }
            </div>

            {/* Loading screen while sending mails */}
            <div hidden={!isSendingOnboardingMails} style={{
                position: "fixed",
                display: "flex",
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: "100vw",
                height: "100vh",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 100
            }}>
                <CircularProgress size={100} />
            </div>

            {/* Confirmation modal */}
            <Modal hidden={isConfirmSelectionHidden} setHidden={setIsConfirmSelectionHidden} title={isCreatingEaterGroup ? "Confirm cretion" : "Confirm join"} >
                <div>
                    {
                        isCreatingEaterGroup ?
                            <h5>Are you sure you want to create eater group <b>{eaterGroupContent.eaterGroupName}</b> with the following user(s) </h5>
                            :
                            <h5>Are you sure you want to add the following user(s) to <b>{eaterGroups.find((item) => item.content.id === eaterGroup)?.content.eaterGroupName}</b></h5>
                    }
                    <h6>Admins:</h6>
                    <div className={classes.emailContainer}>
                        {addedAdminEmails.map(adminEmail => (
                            <div className={classes.adminEmail}>
                                {adminEmail}
                            </div>
                        ))}
                    </div>
                    <h6>Eaters:</h6>
                    <div className={classes.emailContainer}>
                        {addedUserEmails.map(email => (
                            <div className={classes.email}>
                                {email}
                            </div>
                        ))}
                    </div>
                    <div>
                        {
                            isCreatingEaterGroup ?
                                <CancelCrudButtons
                                    hidden={isConfirmSelectionHidden}
                                    setHidden={setIsConfirmSelectionHidden}
                                    isDelete={false}
                                    postButtonText='Creat Eater Group'
                                    postEntity={postOnboardEaterGroup}
                                    disabledPostButton={isSendingOnboardingMails} />
                                :
                                <CancelCrudButtons
                                    hidden={isConfirmSelectionHidden}
                                    setHidden={setIsConfirmSelectionHidden}
                                    isDelete={false}
                                    postButtonText='Add user(s)'
                                    postEntity={postOnboardEaterGroup}
                                    disabledPostButton={isSendingOnboardingMails} />
                        }
                    </div>
                </div>
            </Modal>
        </div>
    )
}